import api from './index';
import { generateStrongPassword } from '../utils/passwordGenerator';

/**
 * Get all users (admin only)
 * @returns {Promise<Array>} - List of users
 */
export const getUsers = async () => {
  const response = await api.get('/admin/users');
  return response.data;
};

/**
 * Create a new user (admin only)
 * @param {Object} userData - New user data without password
 * @returns {Promise<Object>} - Created user data and generated password
 */
export const createUser = async (userData) => {
  // Generate a strong password for the new user
  const password = generateStrongPassword();
  
  // Send request with the generated password
  const response = await api.post('/admin/users', { 
    ...userData, 
    password 
  });
  
  // Return both the server response and the generated password
  return {
    user: response.data.user,
    generatedPassword: password,
    success: response.data.success,
    message: response.data.message
  };
};

/**
 * Activate a user (admin only)
 * @param {number} userId - User ID to activate
 * @returns {Promise<Object>} - Updated user data
 */
export const activateUser = async (userId) => {
  const response = await api.patch(`/admin/users/${userId}/activate`);
  return response.data;
};

/**
 * Deactivate a user (admin only)
 * @param {number} userId - User ID to deactivate
 * @returns {Promise<Object>} - Updated user data
 */
export const deactivateUser = async (userId) => {
  const response = await api.patch(`/admin/users/${userId}/deactivate`);
  return response.data;
};
